import { render, staticRenderFns } from "./ChangeEmail2.vue?vue&type=template&id=70d94ccb&scoped=true"
import script from "./ChangeEmail2.vue?vue&type=script&lang=js"
export * from "./ChangeEmail2.vue?vue&type=script&lang=js"
import style0 from "./ChangeEmail2.vue?vue&type=style&index=0&id=70d94ccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d94ccb",
  null
  
)

export default component.exports